<template>
    <div :id="'module-button-' + dModule.id">
        <div :class="dModule.layout.alignment">
            <a
                class="button blank-href"
                :href="dModule.data.redirectTarget"
                :style="buttonStyle"
                :target="dModule.data.redirectType"
            >
                {{ dModule.data.label }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "ButtonModule",
    props: {
        data: Object,
    },
    data() {
        return {
            dModule: this.data,
        };
    },
    computed: {
        buttonStyle() {
            let borderRadius = 0;
            if (this.dModule.layout.radius == "edged") {
                borderRadius = 5;
            } else if (this.dModule.layout.radius == "rounded") {
                borderRadius = 25;
            }

            let width = "max-content";
            if (this.dModule.layout.size == "half") {
                width = "50%";
            } else if (this.dModule.layout.size == "full") {
                width = "100%";
            }

            return {
                color: this.dModule.layout.textColor + " !important",
                backgroundColor: this.dModule.layout.backgroundColor,
                borderColor: this.dModule.layout.borderColor,
                borderRadius: borderRadius + "px",
                width: width,
            };
        },
    },
};
</script>

<style scoped>
.button {
    display: inline-block;
    padding: 5px 15px 5px 15px;
    text-align: center;
    border: 1px solid;
    border-radius: 5px;
}
</style>
